import * as config from '../config'
import text from '../lang/ru/menu'
import helper from '../helpers'
import {MyDOMElement} from '../class/MyDOMElement'
import {AddEvents} from "../class/AddEvents";
import {AlignGrid} from "../class/alignGrid";
import {Align} from "../class/align";

export default class Menu extends Phaser.Scene {

    constructor() {
        super({
            key: 'Menu'
        });
    }

    preload() {
        this.load.image('manager', './image/manager.png')
    }

    create() {
        this.aGrid = new AlignGrid({scene: this, rows: 15, cols: 15});
        let manager = {
            x: config.width / 2 + config.width / 3 - config.width / 12,
            y: config.height / 2
        };
        manager = this.add.image(
            manager.x,
            manager.y,
            'manager')
        Align.scaleToGameW(manager, .35)
        const wordWrap = {width: config.width / 2 - config.width / 12};
        if (wordWrap.width < 400) {
            wordWrap.width = 400;
        }
        const titleStyle = {
            fontSize: '88px',
            fontFamily: 'Arial',
            color: '#ffffff',
            wordWrap
        };
        const defaultStyle = {
            fontSize: '38px',
            fontFamily: 'Arial',
            color: '#ffffff',
            wordWrap
        };
        const smallStyleSilver = {
            fontSize: '38px',
            fontFamily: 'Arial',
            color: '#4C4C4C',
            wordWrap
        };
        const smallStyleWhite = {
            fontSize: '32px',
            fontFamily: 'Arial',
            color: '#FFFFFF',
            wordWrap
        };
        let textX = config.width - (manager.x + manager.displayWidth / 2 - 25);
        if (textX < 50) {
            textX = 50;
        }
        let textObj = this.make.text({
            x: textX,
            y: 40,
            text: text.title,
            style: titleStyle,
            add: true
        });
        textObj = this.make.text({
            x: textX,
            y: helper.textPadding(textObj, 40, 'y'),
            text: text.rules,
            style: defaultStyle,
            add: true
        });
        textObj = this.make.text({
            x: textX,
            y: helper.textPadding(textObj, 20, 'y'),
            text: text.lines[0],
            style: defaultStyle,
            add: true
        });
        textObj = this.make.text({
            x: textX,
            y: helper.textPadding(textObj, 20, 'y'),
            text: text.lines[1],
            style: defaultStyle,
            add: true
        });
        textObj = this.make.text({
            x: textX,
            y: helper.textPadding(textObj, 20, 'y'),
            text: text.lines[1],
            style: defaultStyle,
            add: true
        });
        if (localStorage.getItem('deadline-game')) {
            textObj = this.make.text({
                x: textX,
                y: helper.textPadding(textObj, 40, 'y'),
                text: text.bestResult,
                style: titleStyle,
                add: true
            });
            let lastX = textObj.x + textObj.displayWidth / 2
            textObj = this.make.text({
                x: textX,
                y: helper.textPadding(textObj, 40, 'y'),
                text: text.time,
                style: smallStyleSilver,
                add: true
            })
            let lastY = textObj.y
            textObj = this.make.text({
                x: textX,
                y: helper.textPadding(textObj, 5, 'y'),
                text: helper.getBestTime(),
                style: smallStyleWhite,
                add: true
            })
            textObj = this.make.text({
                x: lastX,
                y: lastY,
                text: text.project,
                style: smallStyleSilver,
                add: true
            })
            textObj = this.make.text({
                x: lastX,
                y: helper.textPadding(textObj, 5, 'y'),
                text: helper.getBestProject(),
                style: smallStyleWhite,
                add: true
            })
        }


        let startGame = new MyDOMElement(
            this,
            manager.x - 50,
            manager.y + manager.displayHeight / 2 - 200,
            'button',
            'btn btn-primary px-4',
            'Начать игру',
            'font-size: 42px'
        );

        startGame.addListener('click keypress');
        new AddEvents(startGame,['click'], () => {
            this.scene.start('Loading')
            this.scene.stop('Menu')
        })
    }

}
